import { render, staticRenderFns } from "./ListCashRegister.vue?vue&type=template&id=2f2e7888"
import script from "./ListCashRegister.vue?vue&type=script&lang=js"
export * from "./ListCashRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports